// 회신 이메일 형식 검증 — TLD 를 포함한 최소 형태만 통과 (a@b 는 거부)
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function isValidEmail(value) {
  return EMAIL_RE.test((value || '').trim())
}

export default isValidEmail
